<template>
    <main class="main-signin text-center">
        <form class="form-signin" @submit.prevent="login">
            <h1 class="h3 mb-3 font-weight-normal">Fazer login</h1>
            <label for="inputUsername" class="sr-only">Usuário</label>
            <input type="text" id="inputUsername" v-model="username" class="form-control" placeholder="Usuário" autocomplete="off" spellcheck="false" required autofocus>
            <label for="inputPassword" class="sr-only">Senha</label>
            <input type="password" id="inputPassword" v-model="password" class="form-control" placeholder="Senha" autocomplete="off" spellcheck="false" required>
            <button class="btn btn-lg btn-warning btn-block" type="submit">
                <i class="fas fa-sign-in-alt mr-2"></i>Entrar
            </button>
        </form>
      <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    </main>
</template>

<script>
import {api} from '../api'
import Swal from 'sweetalert2'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
    data() {
        return {
            username: '',
            password: '',
            loading: false,
            network_erros: {
				0: {
					message: 'Não há conexão com a internet!'
                },
                401: {
                    message: 'Você não tem autorização para realizar essa operação!'
                },
				404: {
					message: 'Página solicitada não foi encontrada!'
				},
				500: {
					message: 'O servidor está passando por problemas técnicos!'
				},
				408: {
					message: 'Por favor, verifique sua conexão de rede e tente novamente!'
				}					
			}
        }
    },
    components: {
        Loading
    },
    methods: {
        login() {

            const self = this;

            if (self.username == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe seu usuário!',
                    'warning'
                );
            } else if (self.password == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe sua senha!',
                    'warning'
                );
            } else {
                
                self.loading = true;

                api.post('login', {
                    username: self.username,
                    password: self.password
                }).then((response) => {
                    switch(response.data.result) {
                        case 'success':
                            self.setItem('token', response.data.token).then(() => {
                                self.setItem('auth', JSON.stringify(response.data.user)).then(() => {
                                    window.location.reload();
                                });
                            });
                        break;
                        default:
                            Swal.fire(
                                'Atenção!',
                                response.data.message,
                                'warning'
                            ); 
                        break;
                    }
                }).catch((error) => {
                    try {
                        Swal.fire(
                            'Falha',
                            self.network_erros[error.status]['message'],
                            'warning'
                        );
                    } catch(e) {
                        Swal.fire(
                            'Falha',
                            self.network_erros[408]['message'],
                            'warning'
                        );
                    }                
                }).finally(() => {
                    self.loading = false;
                });
            } 
        },
        setItem(key, value) {
            return Promise.resolve().then(() => {
                window.localStorage.setItem(key, value);
            });
        },
    },
    watch: {
        username(value) {
            return this.username = value.toLowerCase().replace(/[^a-z0-9.]/g, '');
        },
        password(value) {
            return this.password = value.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
        }
    }
}
</script>

<style scoped>
.main-signin {
  height: 100vh;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #f5f5f5;
}
.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="password"] {
  margin: 10px 0;
}
</style>